<script>
export default {
  name: "hitchhikingDetails",
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      loading: false,
      activeName: "order",
      map: null,
      // 配置项
      customOptions: {
        // 请求的列表url
        url: "/api/v1/manage/airport/status/record",
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 20, // 每页条数
        },
        search: [],
      },
      // 表头
      columns: [
        { prop: "remark", label: "记录内容", minWidth: 280 },
        { prop: "operator", label: "操作人", minWidth: 150 },
        { prop: "created", label: "记录时间", minWidth: 130 },
      ],
    };
  },
  mounted() {
    this.customOptions.params.orderId = this.rowData.id;
    this.$nextTick(() => {
      this.initMap();
    });
  },
  methods: {
    initMap() {
      this.map = new AMap.Map("order-map", {
        mapStyle: "amap://styles/572516903e2f1273ed9c97f54ebacd89",
        // resizeEnable: true,
        animateEnable: true,
        zoom: 11,
        center: new AMap.LngLat(104.065861, 30.657401),
      });
      this.map.on("complete", () => {
        let markers = [
          {
            pointLat: this.rowData.startPointLat,
            pointLng: this.rowData.startPointLng,
            pointName: this.rowData.startPointName,
            label: "预约起点",
            color: "#4dace2",
            icon: require("@/assets/img/markerBegin.png"),
            key: 'markerBegin'
          },
          {
            pointLat: this.rowData.endPointLat,
            pointLng: this.rowData.endPointLng,
            pointName: this.rowData.endPointName,
            label: "预约终点",
            color: "#47c147",
            icon: require("@/assets/img/markerEnd.png"),
            key: 'markerEnd'
          },
          {
            pointLat: this.rowData.realStartPointLat,
            pointLng: this.rowData.realStartPointLng,
            pointName: this.rowData.realStartPointName,
            label: "实际起点",
            color: "#4dace2",
            icon: require("@/assets/img/markerBegin.png"),
            key: 'markerBegin1'
          },
          {
            pointLat: this.rowData.realEndPointLat,
            pointLng: this.rowData.realEndPointLng,
            pointName: this.rowData.realEndPointName,
            label: "实际终点",
            color: "#47c147",
            icon: require("@/assets/img/markerEnd.png"),
            key: 'markerEnd1'
          },
        ];

        markers.forEach((item) => {
          if (this[item.key]) {
            this[item.key].setMap(null);
          }
          if (item.pointLat && item.pointLng) {
            let content = `<div  style="
                                padding: 10px;
                                border-radius: 4px;
                                font-size: 16px;
                                color: #FFFFFF;
                                box-shadow: 2px 2px 4px 0 rgba(0,0,0,0.30);
                                background-color: ${item.color};">
                                <div>${item.label}：${item.pointName}</div>
                            </div>`;
            this[item.key] = new AMap.Marker({
              position: new AMap.LngLat(item.pointLng, item.pointLat),
              icon: item.icon,
              map: this.map,
            });
            this[item.key].setLabel({
              offset: new AMap.Pixel(0, -8),
              content: content,
              direction: "right",
            });
          }
        });
        this.$nextTick(() => {
          this.map.setFitView();
        });
      });
    },
  },
};
</script>

<template>
  <div class="hitchhikingDetails">
    <el-tabs v-model="activeName" type="card">
      <!-- 订单信息 -->
      <el-tab-pane label="订单详情" name="order">
        <div class="orderContent" style="width: 100%">
          <div class="formTitle">
            <span @dblclick="$utils.dblclickCopy">{{ rowData.orderNo }}</span>
            /
            <span v-if="rowData.status == 5 && !rowData.dispatchAccountName">新订单</span>
            <span v-else>{{ rowData.status | filterConst("CZHITCHHIKINGDAN") }}</span>
          </div>
          <div style="height: 12px"></div>
          <!-- 订单信息 -->
          <el-form label-position="left" label-width="105px">
            <div class="formContent">
              <div class="items">
                <el-form-item label="机构名称">
                  <span class="color-666"> {{ rowData.organizationName }}</span>
                </el-form-item>
              </div>
              <div class="items">
                <el-form-item label="乘客电话">
                  <span class="color-666"> {{ rowData.customerPhone }}</span>
                </el-form-item>
              </div>
              <div class="items">
                <el-form-item label="订单类型">
                  <span class="color-666">{{ rowData.passengerNum }}人 / {{ rowData.seatType | filterConst("SEATTYPE")
                    }}</span>
                </el-form-item>
              </div>
              <div class="items">
                <el-form-item label="下单人">
                  <span class="color-666">{{ rowData.createdAccountName || '-' }}</span>
                </el-form-item>
              </div>
              <div class="items">
                <el-form-item label="下单时间">
                  <span class="color-666">{{ rowData.created | filterTime }}</span>
                </el-form-item>
              </div>
              <div class="items">
                <el-form-item label="线路名称">
                  <span class="color-666">{{ rowData.startStationName }} - {{ rowData.endStationName }}</span>
                </el-form-item>
              </div>
              <div class="items">
                <el-form-item label="调度员">
                  <span class="color-666">{{ rowData.dispatchAccountName || '-' }}</span>
                </el-form-item>
              </div>
              <div class="items">
                <el-form-item label="完成/取消时间">
                  <span class="color-666">{{
                    rowData.finishTime | filterTime
                  }}</span>
                </el-form-item>
              </div>
              <div class="items">
                <el-form-item label="备注">
                  <span class="color-666">{{ rowData.remark || '-' }}</span>
                </el-form-item>
              </div>
            </div>
          </el-form>
          <!-- 车辆信息 -->
          <div class="formTitle">车辆信息</div>
          <div style="height: 12px"></div>
          <el-form label-position="left" label-width="105px">
            <div class="formContent">

              <div class="items">
                <el-form-item label="车辆号牌">
                  <span v-if="rowData.licenseNo" :style="getPlateStyle(rowData.licenseNo)" @dblclick="$utils.dblclickCopy">{{ formatPlateNumber(rowData.licenseNo) }}</span>
                  <span v-else>-</span>
                </el-form-item>
              </div>
              <div class="items">
                <el-form-item label="司机姓名">
                  <span class="color-666" @dblclick="$utils.dblclickCopy">
                    {{ rowData.driverName }}
                  </span>
                </el-form-item>
              </div>
              <div class="items">
                <el-form-item label="司机电话">
                  <span class="color-666" @dblclick="$utils.dblclickCopy">
                    {{ rowData.driverPhone }}
                  </span>
                </el-form-item>
              </div>
            </div>
          </el-form>
          <div class="formTitle">费用信息</div>
          <div style="height: 12px"></div>

          <el-form label-position="left" label-width="105px">
            <div class="formContent">
              <div class="items">
                <el-form-item label="订单金额">
                  <span class="util-money" v-if="rowData.amount || rowData.amount === 0">￥ {{ rowData.amount }}</span>
                  <span class="color-666" v-else>-</span>
                </el-form-item>
              </div>
              <div class="items">
                <el-form-item label="信息费">
                  <span class="util-money" v-if="rowData.serviceFee || rowData.serviceFee === 0">￥ {{ rowData.serviceFee
                    }}</span>
                  <span class="color-666" v-else>-</span>
                </el-form-item>
              </div>
              <div class="items">
                <el-form-item label="司机收入">
                  <span class="util-money" v-if="rowData.driverAmount || rowData.driverAmount === 0">￥ {{
                    rowData.driverAmount }}</span>
                  <span class="color-666" v-else>-</span>
                </el-form-item>
              </div>
              <div class="items">
                <el-form-item label="业务收入">
                  <span class="util-money" v-if="rowData.dispatchAmount || rowData.dispatchAmount === 0">￥ {{
                    rowData.dispatchAmount }}</span>
                  <span class="color-666" v-else>-</span>
                </el-form-item>
              </div>
              <div class="items">
                <el-form-item label="平台收入">
                  <span class="util-money" v-if="rowData.platformAmount || rowData.platformAmount === 0">￥ {{
                    rowData.platformAmount }}</span>
                  <span class="color-666" v-else>-</span>
                </el-form-item>
              </div>
              <div class="items">
                <el-form-item label="技术服务">
                  <span class="util-money" v-if="rowData.technologyAmount || rowData.technologyAmount === 0">￥ {{
                    rowData.technologyAmount }}</span>
                  <span class="color-666" v-else>-</span>
                </el-form-item>
              </div>

            </div>
          </el-form>
          <div class="formTitle">销单信息</div>
          <div style="height: 12px"></div>

          <el-form label-position="left" label-width="105px">
            <div class="formContent">
              <div class="items">
                <el-form-item label="取消类型">
                  <span class="color-666">{{ rowData.cancelType || '-' }}</span>
                </el-form-item>
              </div>
              <div class="items">
                <el-form-item label="取消原因">
                  <span class="color-666">{{ rowData.cancelReason || "-" }}</span>
                </el-form-item>
              </div>
            </div>
          </el-form>
        </div>
        <div id="order-map"></div>
      </el-tab-pane>
      <!-- 跟踪记录 -->
      <el-tab-pane label="跟踪记录" name="map">
        <custom-table ref="customTable" :customOptions="customOptions" :columns="columns" labelWidth="135"
          :refreshShow="false" style="height: calc(100vh - 110px);">
          <template slot-scope="{ item, row }">
            <template v-if="item.prop == 'created'">
              <span> {{ row[item.prop] | filterTime }} </span>
            </template>
            <template v-else>
              <span> {{ row[item.prop] || "-" }} </span>
            </template>
          </template>
        </custom-table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<style scoped lang="less">
.hitchhikingDetails {
  #order-map {
    width: 100%;
    height: 460px;
  }

  .formContent {
    display: flex;
    flex-wrap: wrap;

    .items {
      width: 32%;
      margin-right: 1%;
      word-wrap: break-word;
      /* 旧版浏览器支持 */
      overflow-wrap: break-word;
      /* 标准属性 */
    }
  }

  .message-box {
    margin: 10px 0;
    padding: 10px;
    background: #f3f4f5;

    .message-list {
      display: flex;
      justify-content: flex-end;
      margin: 20px 0;

      .message-info {
        margin: 0 10px;

        .message-content {
          max-width: 300px;
          padding: 5px;
          border-radius: 5px;
          margin: 5px 0;
        }
      }

      .message-head {
        width: 50px;
        height: 50px;
        border-radius: 10px;
        overflow: hidden;

        img {
          width: 50px;
          height: 50px;
        }
      }
    }
  }
}
</style>